import { Box } from '@material-ui/core';
import { formatMoney, OrderDetails, Transaction } from '@nemuru-eng/js-api-client';

import { OrderAction } from '@/components/modules/OrderActivity/types/OrderAction';

import { Text } from '../../../../../../../shared/components/Text';

export const getInfoAndTooltip = (transaction: Transaction, orderDetails: OrderDetails, actions: OrderAction[]) => {
  const currency = orderDetails.currency;
  const filterItemsByIdArray = (idArray, items) => {
    if (!idArray || !items) return [];
    return idArray.map((itemId) => {
      const capture = items.find((item) => item.id === itemId);
      if (capture) return capture;
    });
  };

  const associatedRefunds = filterItemsByIdArray(transaction.refundIds, orderDetails.refunds);
  const associatedCaptures = filterItemsByIdArray(transaction.captureIds, orderDetails.captures);

  const findNumberByActionId = (id) => {
    return actions.find((a) => a.id === id)?.number;
  };
  if (!associatedRefunds.length && !associatedCaptures.length)
    return {
      info: <></>,
      tooltip: <Text tId={'NO_ASSOCIATED_ITEMS'} />,
    };
  const totalReferences = associatedRefunds.length + associatedCaptures.length;
  const tooltipItem = (name, value) => (
    <>
      <Box style={{ display: 'flex', gap: '20px', justifyContent: 'space-between' }}>
        <Box>{name} </Box>
        <Box>{formatMoney({ value: value, currency })}</Box>
      </Box>
    </>
  );
  const tooltip = (
    <>
      <Text tId={'IN_REFERENCE_TO'}></Text>
      {associatedCaptures.map((capture) =>
        tooltipItem(
          <Text tId={'CAPTURE_NUMBER'} dynamicDataTexts={[`${findNumberByActionId(capture.id)}`]} />,
          capture.amount,
        ),
      )}
      {associatedRefunds.map((refund) =>
        tooltipItem(
          <Text tId={'REFUND_NUMBER'} dynamicDataTexts={[`${findNumberByActionId(refund.id)}`]} />,
          -refund.amount,
        ),
      )}
    </>
  );
  if (totalReferences === 1) {
    const reference = [...associatedRefunds, ...associatedCaptures][0];
    const referenceTid = associatedCaptures.length ? 'CAPTURE_NUMBER' : 'REFUND_NUMBER';
    return {
      info: (
        <>
          <Text tId={'FROM'} /> <Text tId={referenceTid} dynamicDataTexts={[`${findNumberByActionId(reference.id)}`]} />
        </>
      ),
      tooltip,
    };
  }
  return {
    info: (
      <>
        <Text
          tId={'FROM_X_CAPTURES_AND_X_REFUNDS'}
          dynamicDataTexts={[associatedCaptures?.length, associatedRefunds?.length]}
        />
      </>
    ),
    tooltip,
  };
};
